import React, { useState, useEffect } from 'react';
import styles from './Refund.module.scss';
import PaginationTable from '../../components/table/pagination-table';
import { ColumnRefund, RefundData } from '../../types/TablesTypes/Refund';
import StatusView from '../../components/StatusView/StatusView';
import TableHeader from '../../components/TableHeader/TableHeader';
import client from '../../api/client';
import { numberWithCommas } from '../../utils/formatNumber';
import {
	openLoader,
	closeLoader,
} from '../../redux/actions/loader/loaderActions';
import { useDispatch, useSelector } from 'react-redux';
import {
	ToastErrorStyles,
} from '../../constants/toastStyles';
import { openToastAndSetContent } from '../../redux/actions/toast/toastActions';
import { Menu, Dropdown as MenuFunc } from 'antd';
import Modal from 'react-modal';
import { customStyles } from '../../constants/modalStyles';
import Single from './Single';
import Bulk from './Bulk';
import { Dayjs } from 'dayjs';
import FilterModal from '../../components/filterConfig/FilterModal';
import {
	dateNow,
	sevenDaysAgo,
	thirtyDaysAgo,
	startOfYear,
	endOfYear,
} from '../../utils/datefunction';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const Refund = () => {
	const dispatch = useDispatch();
	const [tableRow, setTableRow] = useState<any[]>();
	const [modalIsOpenSingle, setIsOpenSingle] = React.useState(false);
	const [modalIsOpenBulk, setIsOpenBulk] = React.useState(false);
	const [refund, setRefund] = useState<any>();
	const [refundId, setRefundId] = useState<number | null>(null);

	// const [apiObject, setApiObject] = useState(null);

	// const { keyB: trxRef } = apiObject?.keyA || [{

	// }];
	const history = useHistory()

	function closeModalSingle() {
		setIsOpenSingle(false);
	}
	function closeModalBulk() {
		setIsOpenBulk(false);
	}

	//PAGINATION
	const [pageNumber, setPageNumber] = React.useState<number>(1);
	const [rowsPerPage, setRowsPerPage] = React.useState<number>(10);
	const [nextPage, setNextPage] = useState<number | null>(null);
	const [previousPage, setPreviousPage] = useState<number | null>(null);

	//FILTERING
	const [value, setValue] = useState('');
	const [dropdown, setDropdown] = useState(false);
	const [eventDate, setEventDate] = useState('');
	const [fromDate, setFromDate] = useState<Dayjs | null | string>('');
	const [toDate, setToDate] = useState<Dayjs | null | string>('');
	const [orderReference, setOrderReference] = useState('');
	const [name, setName] = useState('');
	const [status, setStatus] = useState('');
	const [email, setEmail] = useState('');
	const [bearer, setBearer] = useState(false);

	const { currency } = useSelector((state) => state.appSettingsReducer);

	const clearHandler = () => {
		setEventDate('');
		setFromDate('');
		setToDate('');
		setName('');
		setOrderReference('');
		setStatus('');
		setEmail('');
		setDropdown(false);
		setBearer(true);
	};

	useEffect(() => {
		if (eventDate === 'today') {
			setFromDate(dateNow);
			setToDate(dateNow);
		} else if (eventDate === 'last7days') {
			setFromDate(sevenDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === 'last30days') {
			setFromDate(thirtyDaysAgo);
			setToDate(dateNow);
		} else if (eventDate === 'oneyear') {
			setFromDate(startOfYear);
			setToDate(endOfYear);
		} else {
			setFromDate('');
			setToDate('');
		}
	}, [eventDate]);

	const filteredArray = [
		{
			name: 'Order Reference',
			value: orderReference,
			setValue: setOrderReference,
		},
		{
			name: 'Customer Name',
			value: name,
			setValue: setName,
		},
		{
			name: 'Status',
			value: status,
			setValue: setStatus,
			selective: [
				{ name: 'New' },
				{ name: 'Pending' },
				{ name: 'Processing' },
				{ name: 'Failed' },
				{ name: 'Completed' }
			],
		},
	];

	const fetchRefund = async (isExport: boolean = false) => {
		dispatch(openLoader());
		try {
			const { data }: any = await client.get(
				`/refund/all/paginated?currency=${currency}&status=${status}&orderreference=${orderReference}&customername=${name}&email=${email}&fromdate=${fromDate}&todate=${toDate}&limit=${rowsPerPage}&page=${pageNumber}&IsExport=${isExport}`
			);
			setRefund(data?.data);
			dispatch(closeLoader());
			setBearer(false);
			if (isExport) return data?.data?.items
		} catch (error: any) {
			dispatch(closeLoader());
			if (error?.response?.data?.message === 'Please login again') {
				sessionStorage.clear();
				window.location.href = '/';
			} else {
				const message = error?.response?.data?.message;

				dispatch(
					openToastAndSetContent({
						toastContent: message,
						toastStyles: ToastErrorStyles,
					})
				);
			}
		}
	};

	useEffect(() => {
		let payments = refund
		console.log({ payments })
		setPageNumber(payments?.page?.currentPage || 1);
		setPreviousPage(payments?.page?.currentPage - 1);
		setNextPage(payments?.page?.currentPage + 1);
	}, [refund]);


	useEffect(() => {
		fetchRefund();
	}, [bearer, email, pageNumber, rowsPerPage, currency, status, fromDate, toDate]);

	const dataTransaction = () => {
		const tempArr: RefundData[] = [];
		refund?.items
			?.slice(0)
			.reverse()
			.forEach((transaction: any, index: number) => {
				tempArr.push({
					id: transaction.id,
					amount: `${transaction.currency} ${numberWithCommas(transaction?.refundAmount)}`,
					merchantId: transaction.customerId,
					amountCharged: transaction.amount,
					businessName: transaction.subsidiaryName,
					// transactionReference: transaction?.orderReference,
					date: moment(transaction?.dateCreated).format('MMMM Do YYYY, h:mm a'),
					channelMid: transaction?.processorProviderUserName ?? "N/A",
					customerName: transaction.customerName,
					originalTransactionDate: moment(transaction?.orderDateCreated).format('MMMM Do YYYY, h:mm a'),
					refundReceipt: transaction.providerReceipt ?? "N/A",
					status: (
						<StatusView
							status={transaction?.refundStatus}
							green='Completed'
							red='Declined'
							orange='Processing'
							blue='Awaiting Response'
						/>
					),
					// action: <RefundsMenu customerId={transaction.customer_id} />,
				});
			});
		return tempArr;
	};

	useEffect(() => {
		setTableRow(dataTransaction());
	}, [refund?.items]);

	const menu = (
		<Menu
			items={[
				{
					key: '1',
					label: (
						<p onClick={() => setIsOpenSingle(true)}>Log a single refund</p>
					),
				},
				{
					key: '2',
					label: <p onClick={() => setIsOpenBulk(true)}>Log bulk refunds</p>,
				},
			]}
		/>
	);


	return (
		<div className={styles.dashbordContainer}>
			<TableHeader
				pageName='Refunds'
				dataLength={refund?.page?.total}
				data={refund?.items}
				value={email}
				setValue={setEmail}
				dropdown={dropdown}
				placeHolder='search by email address'
				setDropdown={setDropdown}
				fetchDataHandler={() => fetchRefund(true)}
				newButton={
					<MenuFunc overlay={menu}>
						<div className={styles.createLink}>Log Refund</div>
					</MenuFunc>
				}
				searchfn={true}
				FilterComponent={
					<FilterModal
						eventDate={eventDate}
						setEventDate={setEventDate}
						dropdown={dropdown}
						setDropdown={setDropdown}
						setFromDate={setFromDate}
						setToDate={setToDate}
						fromDate={fromDate}
						toDate={toDate}
						setBearer={setBearer}
						clearHandler={clearHandler}
						filteredArray={filteredArray}
					/>
				}
			/>

			<PaginationTable
				data={tableRow ? tableRow : []}
				columns={ColumnRefund ? ColumnRefund : []}
				value={value}
				emptyPlaceHolder={
					refund?.page?.total == 0
						? 'You currently do not have any data'
						: 'Loading...'
				}
				total={refund?.page?.total}
				totalPage={refund?.page?.totalPage}
				pageNumber={pageNumber}
				setPageNumber={setPageNumber}
				nextPage={nextPage}
				clickAction={(obj) => {
					console.log(obj);
					history.push(`/dashboard/refunds/${obj.id}`)
				}}
				setNextPage={setNextPage}
				previousPage={previousPage}
				setPreviousPage={setPreviousPage}
				rowsPerPage={rowsPerPage}
				setRowsPerPage={setRowsPerPage}
			/>

			{/* //MODAL FOR SINGLE */}
			<Modal
				isOpen={modalIsOpenSingle}
				onRequestClose={closeModalSingle}
				contentLabel='Example Modal'
				style={customStyles}>
				<Single closeModal={closeModalSingle} fn={fetchRefund} />
			</Modal>
			{/* //MODAL FOR BULK */}
			<Modal
				isOpen={modalIsOpenBulk}
				onRequestClose={closeModalBulk}
				contentLabel='Example Modal'
				style={customStyles}>
				<Bulk closeModal={closeModalBulk} fn={fetchRefund} />
			</Modal>
		</div>
	);
};

export default Refund;
